$(function () {
	$('body.no-js')
		.toggleClass('js no-js');

	$('[data-toggle]')
		.on('click', function () {
			$($(this).data('toggle')).toggle();
		});

	$('[data-responsive-toggle]')
		.on('click', function () {
			$($(this).data('responsive-toggle')).each(function () {
				var $target = $(this);

				if ($target.is(':visible')) {
					$target
						.removeClass('responsive-visible')
						.addClass('responsive-hidden');
				} else {
					$target
						.removeClass('responsive-hidden')
						.addClass('responsive-visible');
				}
			});
		});

	$('#emergency_notification').each(function () {
		var
			$notification = $(this).notification()
				.on('notification:hidden', function () {
					var emergencyNotificationCookie = Cookies.getJSON('emergency_notification') || {};

					emergencyNotificationCookie[$notification.data('content-hash')] = Date.now();

					Cookies.set('emergency_notification', emergencyNotificationCookie, { expires: 365 });
				});
	});

	$('.accordion').accordion();
	$('.expanding-schedule').expandingSchedule();

	$('.homepage_alert').each(function () {
		var
			$modal = $(this).modal()
				.on('modal:hidden', function () {
					var homepageAlertCookie = Cookies.getJSON('homepage_alert') || {};

					$('body').css('overflow-y', 'auto');

					homepageAlertCookie[$modal.data('content-hash')] = Date.now();

					Cookies.set('homepage_alert', homepageAlertCookie, { expires: 365 });
				});

		if (!Cookies.getJSON('homepage_alert') || !Cookies.getJSON('homepage_alert')[$modal.data('content-hash')]) {
			$('body').css('overflow-y', 'hidden');
			$modal
				.hide()
				.trigger('modal:open')
				.slideDown();
		}
	});

	$('.section__icon-content .box.link')
		.on('click', function () {
			window.location.href = $(this).find('a.link').attr('href');
		});
});



// WEBPACK FOOTER //
// ./assets/js/components/on-load.js